module.exports = "/assets/4acc260472fbf04be138349c3abf2b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/6A.png
// module id = 1078
// module chunks = 0